'use strict'
import $ from 'jquery'
import 'select2'

const teamsIndex = {
  init() {
    
    $('.js-state-filter').select2({
      theme: "classic"
    }).on('change', function(e) {
      var post    = {};
      post.id = e.target.value;
      post._token = $('meta[name="csrf-token"]').attr('content');
      
      var url = '/estados/busca-cidades/' + post.id ;
      
      $.ajax({
        type: "GET",
        url : url,
        data : post,
        cache : false,
        dataType: 'json',
      }).then(function(data){
        
        $('#js-cities').empty();
        $('#js-cities').append('<option value="">Selecione uma cidade</option>');
        
        $.each(data, function(index, element) {
          
          var option = new Option(element, index);
          $('#js-cities').append(option);
          
        });
        
        $('#js-cities').trigger('change');
        
      });
    });
    
    $('#js-cities').select2({
      placeholder: "Primeiro selecione um estado",
      theme: "classic",
      sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
    });
    
    $('.js-unities').select2({
      placeholder: "Selecione uma unidade",
      theme: "classic",
      data: JSON.parse(sessionStorage.unities)
    });
    
    $('.js-unities').val(JSON.parse(sessionStorage.unity_selected));
    $('.js-unities').trigger('change');
    
  }
}

export default teamsIndex